export const SOCKET = 'socket'
export const CHAT_CHECK = 'chatCheck'
export const CHAT_LIST = 'chatList'
export const CHAT_MESSAGES = 'chatMessages'
